import React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import { Avatar, Box, Grid, Skeleton } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CardContent from "@mui/material/CardContent";

const ChatCardSkeleton = () => {
  return (
    <>
      <Card
        sx={{
          maxWidth: 345,
          direction: "rtl",
          background: "#34495E !important",
          //   color: "#fff",
          border: "none",
          minWidth: 340,
          minHeight: "80px",
          paddingX: "1rem",
          overflow: "initial !important",
          marginRight: "15px",
        }}
      >
        <CardHeader
          color="#fff !important"
          className="chat-header"
          sx={{
            borderBottom: "1px solid rgba(255,255,255,.1)",
            paddingY: "0px !important",
            paddingRight: "0px !important",
          }}
          avatar={
            <Avatar
              className="chat-card-avatar"
              sx={{
                bgcolor: "E5E1DA",
                marginLeft: "7px",
              }}
              aria-label="recipe"
            >
              <Skeleton
                animation="wave"
                variant="circular"
                width={50}
                height={50}
                sx={{ backgroundColor: "#E5E1DA" }}
              />
            </Avatar>
          }
          action={
            <IconButton
              aria-label="settings"
              className="chatCardOptions"
            ></IconButton>
          }
          title={
            <span>
              <Skeleton
                animation="wave"
                variant="rectangular"
                width={140}
                height={20}
                sx={{
                  backgroundColor: "#E5E1DA",
                  marginTop: "10px",
                  borderRadius: "5px",
                  marginBottom: "5px",
                }}
              />
            </span>
          }
        />

        <CardContent
          sx={{
            marginTop: "10px",
            paddingTop: "4px",
            paddingBottom: "10px !important",
            paddingX: "3px !important",
          }}
        >
          <Grid
            container
            justifyContent={"right"}
            alignItems={"center"}
            // marginBottom={"20px"}
          >
            <Grid item xs={10} textAlign={"right"}>
              <Skeleton
                variant="rectangular"
                animation="wave"
                width={"100%"}
                height={50}
                sx={{ backgroundColor: "#E5E1DA", borderRadius: "5px" }}
              />
            </Grid>
          </Grid>
          <Box
            marginTop={"10px"}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
              justifyContent: "center",
            }}
          >
            <Skeleton
              variant="rectangular"
              animation="wave"
              width={"100%"}
              height={100}
              sx={{
                backgroundColor: "#E5E1DA",
                borderRadius: "5px",
                marginBottom: "5px",
              }}
            />
            <Skeleton
              variant="rectangular"
              animation="wave"
              width={50}
              height={20}
              sx={{ backgroundColor: "#E5E1DA", borderRadius: "5px" }}
            />
          </Box>
        </CardContent>
      </Card>
    </>
  );
};

export default ChatCardSkeleton;
